import { ListComponentBaseProps, Table, TableRowSpanningBoxProps } from '@hevoio/hevo-ui-toolkit';
import { useMemo, useState } from 'react';
import { getConnectivityColumns } from './ConnectivityColumns';
import { ConnectivityBanner } from './ConnectivityBanner';
import { AcceptConnectionDrawer } from './AcceptConnectionDrawer/AcceptConnectionDrawer';
import { VPCPeeringConnection } from '../interface';

export interface ConnectivityTableContext {
  onHowToAccept: (connection: VPCPeeringConnection) => void;
}

function ConnectivityRowSpanningBox(
  props: TableRowSpanningBoxProps<VPCPeeringConnection, ConnectivityTableContext>
) {
  return <ConnectivityBanner {...props} />;
}

export function ConnectivityTable({ data }: ListComponentBaseProps<VPCPeeringConnection[]>) {
  const [acceptConnection, setAcceptConnection] = useState<VPCPeeringConnection | null>(null);

  const columns = useMemo(() => getConnectivityColumns(), []);

  const rows = (data ?? []).map(item => ({ id: item.id, data: item }));

  const globalContext: ConnectivityTableContext = {
    onHowToAccept: setAcceptConnection
  };

  return (
    <>
      <Table<VPCPeeringConnection, ConnectivityTableContext>
        dataId='connectivity-table'
        columns={columns}
        rows={rows}
        globalContext={globalContext}
        RowSpanningBox={ConnectivityRowSpanningBox}
      />
      <AcceptConnectionDrawer
        open={!!acceptConnection}
        connection={acceptConnection}
        onClose={() => setAcceptConnection(null)}
      />
    </>
  );
}
